<h2>{{ 'companyMain.greeting' | translate : {company_name: company_name} }}</h2>
<p *ngIf="jobOffers.length > 0">{{ 'companyMain.messages.hasOffers' | translate }}</p>
<p *ngIf="jobOffers.length === 0">{{ 'companyMain.messages.noOffers' | translate }}</p>
<!-- Start Generation Here -->
<div class = "job-offers-container">  

  <div class ="job-offer-card create-job-offer-card">
    <h4 *ngIf="jobOffers.length == 0">{{ 'companyMain.createOffer.firstOffer' | translate }}</h4>
    <h4 *ngIf="jobOffers.length != 0">{{ 'companyMain.createOffer.newOffer' | translate }}</h4>
    <p style = "margin-top: 10px;">{{ 'companyMain.createOffer.description' | translate }}</p>
    <div class = "button-container">
      <a href="/dashboard/company/create-job-offer/step-1?offer_id">
          <button mat-button  (click)="create_offer()" class = "link-button" >{{ 'companyMain.createOffer.button' | translate }}</button>
      </a>
    </div>
  </div>


  <div *ngFor="let jobOffer of jobOffers" class ="job-offer-card">
    <h4>{{ jobOffer.role_name }} - {{ jobOffer.role_seniority }}</h4>
    <p *ngIf="jobOffer.status == 0" style = "margin-top: 10px;">{{ 'companyMain.jobOffer.missingDetails' | translate }}</p>
    <p *ngIf="jobOffer.status == 1" style = "margin-top: 10px;">{{ 'companyMain.jobOffer.startDate' | translate: {date: (jobOffer.created_time | date:'dd/MM/yyyy')} }}</p>
    <p *ngIf="jobOffer.status > 1" style = "margin-top: 10px;">{{ 'companyMain.jobOffer.closedOffer' | translate: {date: (jobOffer.edited_time | date:'dd/MM/yyyy')} }}</p>

    <div class = "button-container">

      <a *ngIf="jobOffer.status == 0" href="/dashboard/company/create-job-offer/step-{{ jobOffer.step }}?offer_id={{ jobOffer.id }}">
          <button mat-button class = "link-button" >{{ 'companyMain.jobOffer.actions.continue' | translate }}</button>
        </a>
        <a *ngIf="jobOffer.status == 1" href="/dashboard/company/create-job-offer/step-1?offer_id={{ jobOffer.id }}">
            <button mat-button  class = "link-button" >{{ 'companyMain.jobOffer.actions.editOffer' | translate }}</button>
        </a>
        <a *ngIf="jobOffer.status > 1">
          <button mat-button  class = "link-button" disabled="true" >{{ 'companyMain.jobOffer.actions.finished' | translate }}</button>
      </a>
    </div>
  </div>
  
</div>

<!-- End Generation Here -->


